import React, { Component } from "react";
import { BrowserRouter, HashRouter} from "react-router-dom";
import AppRoutes from "../routers/OfflineRouter";

import { startup } from "../redux/actions/Session";
import { updateClient } from "../redux/actions/Firebase";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class SessionContainer extends Component {

    render(){
        return(
            <BrowserRouter>
                <HashRouter noslash>
                    <div style={{padding: 50}}>
                        <AppRoutes />
                    </div>
                </HashRouter>
            </BrowserRouter>
        )
    }

}

const mapStateToProps = state => {
    return { session: state.session.user};
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({startup, updateClient}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SessionContainer);